import React, { useState, useEffect } from "react";
import styles from "./shares.module.scss";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { fetchConversations } from "actions/conversations";
import { EntityCard, PlaceholderCard } from "../entityCard";
import Button from "components/button";
import { EmptyMessage } from "../../../../components/emptyMessage";
import InfiniteScroll from "react-infinite-scroller";
import { fetchSharesForStakeholders } from "actions/meeting";

export default function Shares({ handleClick }) {
  const dispatch = useDispatch();

  const conversations = useSelector(
    (state) => _.get(state, "meeting.shares") || []
  );
  const loadingShares = useSelector(
    (state) => _.get(state, "meeting.loadingShares") || false
  );
  const meetingContacts = useSelector(
    (state) => _.get(state, "selection.meetingDetails.attendeeIds") || {}
  );
  const user = useSelector((state) => _.get(state, "users.profile.item")) || {};

  useEffect(() => {

    if(_.size(meetingContacts) === 0 || _.size(user) === 0){
      return;
    }

    const userEmailDomain = user.email ? user.email.split("@")[1] : null;
    const filteredEmails = meetingContacts.filter((email) => {
        const parts = email.split("@");
        const domain = parts.length > 1 ? parts[1] : null;
        return domain !== userEmailDomain;
      });

    dispatch(
      fetchSharesForStakeholders(filteredEmails, 0, 20)
    );
  }, [user, meetingContacts]);

  return (
    <>
      <div className={styles.header}>
        <i className="paperflite-flash" />
        Snapshot
      </div>

      <div className={styles.contentContainer}>
        <div className={styles.header}>
          /List of past shares
        </div>
        <div className={styles.assetsContainer}>
          {loadingShares ? (
            _.map(Array(3).fill(), (_, index) => (
              <PlaceholderCard key={index} />
            ))
          ) : _.size(conversations) > 0 ? (
            _.map(conversations.slice(0, 3), (item) => (
              <EntityCard key={item.share.id} entity={item} />
            ))
          ) : (
            <EmptyMessage
              src="/images/meeting/no_materials.png"
              message="No shares made"
            />
          )}
        </div>

        {_.size(conversations) > 1 && (
          <Button
            text="View all"
            icon="paperflite-right-arrow"
            handleButtonClick={() => handleClick("shares")}
          />
        )}
      </div>
    </>
  );
}

export function SharesDetails() {
  const dispatch = useDispatch();

  const conversations = useSelector(
    (state) => _.get(state, "meeting.shares") || []
  );
  const currentPage = useSelector(
    (state) => _.get(state, "meeting.pagination.current") || 0
  );
  const totalPages = useSelector(
    (state) => _.get(state, "meeting.pagination.totalPages") || 0
  );
  const loadingShares = useSelector(
    (state) => _.get(state, "meeting.loadingShares") || false
  );

  const meetingContacts = useSelector(
    (state) => _.get(state, "selection.meetingDetails.attendeeIds") || {}
  );
  const user = useSelector((state) => _.get(state, "users.profile.item")) || {};

  const loadMoreItems = () => {
  if (loadingShares) return;

  if (currentPage < totalPages) {
    const userEmailDomain = user.email ? user.email.split("@")[1] : null;
    const filteredEmails = meetingContacts.filter((email) => {
        const parts = email.split("@");
        const domain = parts.length > 1 ? parts[1] : null;
        return domain !== userEmailDomain;
      });
      
    dispatch(
      fetchSharesForStakeholders(
        filteredEmails, currentPage + 1, 20
      )
    );
  }
};

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.subHeader}>
        Here's a list of shares made
      </div>

      <InfiniteScroll
        pageStart={0}
        hasMore={currentPage < totalPages }
        loadMore={loadMoreItems}
        className={styles.shareDetails}
      >
        {_.map(conversations, (item) => (
          <EntityCard key={item.share.id} entity={item} />
        ))}

        {loadingShares && _.map(Array(1).fill(), (_, index) => (
          <PlaceholderCard key={index} />
        ))}
      </InfiniteScroll>
    </div>
  );
}
